// Module
var code = "<md-button class=\"btnEquipment\" ng-click=\"$ctrl.switchData()\">{{$ctrl.label}} <span ng-if=\"$ctrl.switchCount\">({{$ctrl.switchCount}})</span></md-button>\n";
// Exports
module.exports = code;